import { RRITag } from '../../tags/interfaces/tag.interface';

export interface RRITagValueFilter extends RRITag {
  value: string;
  jsonSchema?: string;
}
